// types
import type { TradeInIntelligenceMatchMethod } from '@makemydeal/dr-dash-types';

export type DealTradeVehicle = {
    vin?: string | null;
    year?: string | number | null;
    make?: string | null;
    model?: string | null;
    value?: number | null;
};

export type ValuedVehicle = {
    vin: string | null;
    year: number | null;
    make: string | null;
    model: string | null;
};

const toTokens = (value: unknown): string[] =>
    value === null || value === undefined
        ? []
        : String(value)
              .toLowerCase()
              .split(/\s+/)
              .map((token) => token.replace(/[^a-z0-9]/g, ''))
              .filter(Boolean);

export const normalizeVehicleText = (value: unknown): string => toTokens(value).join('');

const normalizeYear = (value: unknown): string => {
    const year = normalizeVehicleText(value);
    return Number(year) > 0 ? String(Number(year)) : '';
};

const startsWithTokens = (tokens: string[], needle: string): boolean => {
    let joined = '';
    for (let index = 0; index < tokens.length && joined.length < needle.length; index++) {
        joined += tokens[index];
    }
    return joined === needle;
};

export const isBlankTrade = (trade: DealTradeVehicle): boolean =>
    !normalizeVehicleText(trade.vin) &&
    !normalizeYear(trade.year) &&
    !normalizeVehicleText(trade.make) &&
    !normalizeVehicleText(trade.model) &&
    !(Number(trade.value) > 0);

export const isComparableTrade = (trade: DealTradeVehicle): boolean =>
    normalizeVehicleText(trade.vin).length === 17 ||
    (!!normalizeYear(trade.year) && !!normalizeVehicleText(trade.make) && !!normalizeVehicleText(trade.model));

export const matchVehicle = (trade: DealTradeVehicle, valued: ValuedVehicle): TradeInIntelligenceMatchMethod | null => {
    const tradeVin = normalizeVehicleText(trade.vin);
    const valuedVin = normalizeVehicleText(valued.vin);
    if (tradeVin && valuedVin) {
        return tradeVin === valuedVin ? 'vin' : null;
    }

    const tradeYear = normalizeYear(trade.year);
    const tradeMake = normalizeVehicleText(trade.make);
    const tradeModel = normalizeVehicleText(trade.model);
    const valuedYear = normalizeYear(valued.year);
    const valuedMake = normalizeVehicleText(valued.make);
    const valuedModelTokens = toTokens(valued.model);

    if (!tradeYear || !tradeMake || !tradeModel || !valuedYear || !valuedMake || valuedModelTokens.length === 0) {
        return null;
    }

    return tradeYear === valuedYear && tradeMake === valuedMake && startsWithTokens(valuedModelTokens, tradeModel) ? 'ymm' : null;
};
